<div class="content-block has-padding" [class.block-loader]="(loader.isLoading$ | async)">

	<div class="content-block-button">
		<a page-header-area="button" class="btn btn-primary" translate="Actions.AddUsers" data-cy="AddUsers" (click)="createUser()"></a>
	</div>

	<loader-spinner [model]="loader"/>

	<div class="content-block-negative">
		<federation-users-list-table [list]="list$ | async" [listHandler]="listHandler"
			(status)="updateStatus($event)"
			(registrationRequest)="updateRegistrationRequest($event)"
			[currentUser]="currentUser$ | async"
		/>

		<layout-list-paging [list]="list$ | async" [listHandler]="listHandler"/>
	</div>
</div>
